import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

// ============================================
// Container
// ============================================
export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
  marginTop: '24px',
});

// ============================================
// Header Section
// ============================================
export const HeaderSection = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const WriteButton = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '12px 16px',
  borderRadius: '8px',
  backgroundColor: '#4AB3BC',
  color: '#fff',
  fontSize: '16px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#4AB3BC',
  },
});

// ============================================
// Table
// ============================================
export const TableContainer = styled(Box)({
  width: '100%',
  border: '1px solid #d9d9d9',
  borderRadius: '8px',
  overflow: 'hidden',
});

export const TableHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#f2f2f2',
  borderBottom: '1px solid #d9d9d9',
  padding: '0 16px',
});

export const TableHeaderCell = styled(Box, {
  shouldForwardProp: prop => prop !== 'width',
})(({ width }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px',
  width: width || 'auto',
}));

export const TableHeaderText = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: '#262626',
});

export const TableBody = styled(Box)({
  maxHeight: '400px',
  overflowY: 'auto',
});

export const TableRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#fff',
  borderBottom: '1px solid #d9d9d9',
  padding: '16px',
  height: '60px',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    backgroundColor: '#f9f9f9',
  },
});

export const TableCell = styled(Box, {
  shouldForwardProp: prop => prop !== 'width',
})(({ width }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 12px',
  width: width || 'auto',
}));

export const TableCellText = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  color: '#262626',
  textAlign: 'center',
});

// ============================================
// Action Buttons
// ============================================
export const ActionButtonGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
});

export const EditButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 16px',
  height: '32px',
  borderRadius: '4px',
  border: '1px solid #d9d9d9',
  backgroundColor: '#fff',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

export const EditButtonText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#55C982',
  whiteSpace: 'nowrap',
});

export const DeleteButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 16px',
  height: '32px',
  borderRadius: '4px',
  border: '1px solid #d9d9d9',
  backgroundColor: '#fff',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
});

export const DeleteButtonText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#EE735A',
  whiteSpace: 'nowrap',
});

// ============================================
// Empty State
// ============================================
export const EmptyState = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '60px 0',
  backgroundColor: '#fff',
});

export const EmptyStateText = styled(Typography)({
  fontSize: '14px',
  color: '#999',
});

// ============================================
// Icon
// ============================================
export const WriteIcon = styled('img')({
  width: '24px',
  height: '24px',
});
